const ReturnStatusOptions = [
  { label: "Requested", value: "requested", isEnabled: [] },
  {
    label: "Approved",
    value: "approved",
    isEnabled: ["requested", "rejected"],
  },
  { label: "Rejected", value: "rejected", isEnabled: ["requested"] },
  {
    label: "Refunded",
    value: "refunded",
    isEnabled: ["approved", "received"],
  },
  {
    label: "Replacement",
    value: "replacement",
    isEnabled: ["approved", "received"],
  },
  { label: "Returned", value: "returned", isEnabled: ["approved"] },
  {
    label: "Received",
    value: "received",
    isEnabled: ["refunded", "replacement", "returned"],
  },
];

export default ReturnStatusOptions;
